import { Grid, makeStyles, Typography } from "@material-ui/core"
import RoundedButton from "../../../../../components/Actions/RoundedButton"
import SimpleModal from "../../../../../components/Modals/SimpleModal"
import DisplayError from "../../../../../components/Structure/DisplayData/DisplayError"
import Header from "../../../../../components/Structure/Texts/Header"
import system_translations from "../../../../../texts/system_translations"
import useAddPurchaseGroupModal from "./useAddProductToPGModal"
import ProductSearchBar from "../../../../../components/Actions/ProductSearchBar"



const AddProductToPGModal = ({open, onClose, language, onCompleted, id}) => {

    const classes = useStyles()
    const content = system_translations[language].modals.add_product_to_pg
    const {loading, sending, error, form, actions, prod_form, options, product_selected, loading_prod, search} = useAddPurchaseGroupModal({open, language, content, onCompleted, onClose, id})

    return(
        <SimpleModal open={open} onClose={onClose} maxWidth='sm' loading={loading} loading_height={200} >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant='h6'>{content.title}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <Header>{content.form.id_product.tag}</Header>
                    {/* <ProductAutocompleteForm options={options} onChange={actions.onChangeProduct} 
                     onInputChange={actions.onInputChange} onSearchProduct={actions.onSearchProduct} loading={loading_prod}/> */}   
                     <ProductSearchBar options={options} value={search} loading={loading_prod} onSelectProduct={actions.onChangeProduct}
                    onChange={actions.onInputChange} onUpdateSearch={actions.onSearchProduct} />  
                </Grid>
            </Grid>
            <div className={classes.button_container}>
                <DisplayError>{error}</DisplayError>
                <RoundedButton disabled={product_selected === null} onClick={actions.onSubmit} loading={sending}>{content.button}</RoundedButton>
            </div>
        </SimpleModal>
    )

}

export default AddProductToPGModal

const useStyles = makeStyles(theme => ({
    contact_info:{
        padding:'0px 40px'
    },
    button_container:{
        textAlign:'center',
        margin:'40px 0px 0px'
    },
    contact_title:{
        color:theme.palette.primary.dark,
        padding:'20px 0px'
    },
    line:{
        width:'100%',
        height:1,
        background:'rgba(179, 10, 16, 0.26)',
        marginLeft:4
    }
    
    
    
}))